<!-- Loader -->
<div class="loader-overlay" *ngIf="!isDataReady && !hasError">
    <div class="loader"></div>
</div>

<!-- Error UI -->
<div class="error-wrapper" *ngIf="hasError">
    <div class="error-card">
        <div class="error-icon">⚠</div>
        <h2>Error</h2>
        <p>{{ errorMessage }}</p>

        <div class="error-actions">
            <button mat-raised-button color="primary" (click)="ngOnInit()">
                Retry
            </button>

            <button mat-stroked-button color="warn" (click)="closeexp()">
                Close
            </button>
        </div>
    </div>
</div>

<div class="button-container mr-2" *ngIf="!hasError">
    <button mat-raised-button color="primary" (click)="toggleExpandCollapse()" class="custom-btn noPrint">
        {{ isAllExpanded ? 'संक्षिप्त' : 'विस्तृत' }}
    </button>

    <button mat-raised-button color="accent" printSectionId="print-section" ngxPrint [useExistingCss]="true"
        class="custom-btn btn-print noPrint">
        Print
    </button>

    <button mat-raised-button color="primary" (click)="exportExcel('expense-report')"
        class="custom-btn btn-export noPrint">
        Export
    </button>

    <button mat-raised-button color="warn" (click)="closeexp()" class="custom-btn btn-close noPrint">
        Close
    </button>
</div>

<div class="container" id="print-section" *ngIf="!hasError">
    <div class="a4-page" *ngIf="isDataReady">
        <!-- ================= CA HEADER ================= -->
        <div class="ca-header">
            <div class="trust-name">{{ header.name }}</div>

            <div class="trust-address">
                {{ header.addressLine1 }}<br>
                {{ header.addressLine2 }}<br>
                {{ header.cityState }}
            </div>

            <div class="report-title">Balance Sheet</div>

            <div class="report-period">
                {{ header.period }}
            </div>
        </div>

        <div class="schedule-header">
            <h3>THE BOMBAY PUBLIC TRUST ACT, 1950</h3>
            <h4>SCHEDULE - VII</h4>
            <p>(Vide Rule 17 (1))</p>
        </div>

        <table class="header-table">
            <tr>
                <td><b>Name of Public Trust:</b> {{ trust.name }}</td>
                <td class="right"><b>Registration No:</b> {{ trust.registrationNo }}</td>
            </tr>
            <tr>
                <td><b>Balance Sheet as at:</b> {{ trust.balanceDate }}</td>
                <td></td>
            </tr>
        </table>

        <!-- ================= MAIN BALANCE SHEET TABLE ================= -->
        <table class="main-table">
            <tr class="table-head">
                <th class="rs-col1">FUNDS & LIABILITIES</th>
                <th class="rs-col">(Rs)</th>
                <th class="rs-col">(Rs)</th>
                <th class="rs-col1">PROPERTY & ASSETS</th>
                <th class="rs-col">(Rs)</th>
                <th class="rs-col">(Rs)</th>
            </tr>

            <tr>
                <!-- ================= LIABILITIES ================= -->
                <td colspan="3" class="no-padding">
                    <table class="inner-table liabilities-table">
                        <ng-container *ngFor="let group of liabilities">

                            <!-- GROUP ROW (Level 1) -->
                            <tr class="group-row" (click)="toggleGroup(group)">
                                <td class="section">
                                    <span class="toggle">
                                        {{ group.expanded ? '▼' : '▶' }}
                                    </span>
                                    {{ group.title }}
                                </td>
                                <td class="amount">
                                    {{ group.total | number:'1.2-2' }}
                                </td>
                            </tr>

                            <!-- MAIN EXPENSES (Level 2) -->
                            <ng-container *ngIf="group.expanded">
                                <tr *ngFor="let mainExp of group.mainExpenses">
                                    <td colspan="3" class="no-padding">

                                        <table class="inner-sub-table">

                                            <!-- Main Expense Row -->
                                            <tr class="main-exp-row" (click)="toggleMainExpense(mainExp, $event)">
                                                <td class="main-exp-name">
                                                    <span class="toggle sub-toggle">
                                                        {{ mainExp.expanded ? '▼' : '▶' }}
                                                    </span>
                                                    {{ mainExp.name }}
                                                </td>
                                                <td class="amount1">
                                                    {{ mainExp.amount | number:'1.2-2' }}
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>

                                            <!-- SUB EXPENSES (Level 3) -->
                                            <tr *ngFor="let subExp of mainExp.subExpenses" [hidden]="!mainExp.expanded">
                                                <td class="sub-exp-name">
                                                    &nbsp;&nbsp;&nbsp; {{ subExp.name }}
                                                </td>
                                                <td class="amount2">
                                                    {{ subExp.amount | number:'1.2-2' }}
                                                </td>
                                            </tr>

                                        </table>

                                    </td>
                                </tr>
                            </ng-container>

                        </ng-container>
                    </table>
                </td>

                <!-- ================= ASSETS ================= -->
                <td colspan="3" class="no-padding">
                    <table class="inner-table assets-table">
                        <ng-container *ngFor="let group of assets">
                            <!-- GROUP ROW (Level 1) -->
                            <tr class="group-row" (click)="toggleGroup(group)">
                                <td class="section">
                                    <span class="toggle">
                                        {{ group.expanded ? '▼' : '▶' }}
                                    </span>
                                    {{ group.title }}
                                </td>
                                <td class="amount">
                                    {{ group.total | number:'1.2-2' }}
                                </td>
                            </tr>

                            <!-- MAIN EXPENSES (Level 2) - shown when group is expanded -->
                            <ng-container *ngIf="group.expanded">
                                <tr *ngFor="let mainExp of group.mainExpenses">
                                    <!-- Main Expense Row -->
                                    <td colspan="3" class="no-padding">
                                        <table class="inner-sub-table">
                                            <tr class="main-exp-row" (click)="toggleMainExpense(mainExp, $event)">
                                                <td class="main-exp-name">
                                                    <span class="toggle sub-toggle">
                                                        {{ mainExp.expanded ? '▼' : '▶' }}
                                                    </span>
                                                    {{ mainExp.name }}
                                                </td>
                                                <td class="amount1">
                                                    {{ mainExp.amount | number:'1.2-2' }}
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>

                                            <!-- SUB EXPENSES (Level 3) - shown when main expense is expanded -->
                                            <tr *ngFor="let subExp of mainExp.subExpenses" [hidden]="!mainExp.expanded">
                                                <td class="sub-exp-name">
                                                    &nbsp;&nbsp;&nbsp; {{ subExp.name }}
                                                </td>
                                                <td class="amount2">
                                                    {{ subExp.amount | number:'1.2-2' }}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </table>
                </td>
            </tr>

            <!-- TOTAL ROW -->
            <tr class="total-row">
                <td><b>Total</b></td>
                <td class="amount"><b>{{ totalLiabilities | number:'1.2-2' }}</b></td>
                <td></td>
                <td><b>Total</b></td>
                <td class="amount"><b>{{ totalAssets | number:'1.2-2' }}</b></td>
                <td></td>
            </tr>
        </table>

        <!-- ================= FOOTER ================= -->
        <div class="footer-ca">
            <!-- Left block -->
            <div class="footer-left">
                <div><b>PLACE :</b> {{ footer.place }}</div>
                <div><b>UDIN :</b> {{ footer.udin }}</div>
                <div><b>Dated :</b> {{ footer.date }}</div>
            </div>

            <!-- Center block -->
            <div class="footer-center">
                <div><b>{{ footer.caName }}</b></div>
                <div>Proprietor / M. No {{ footer.membershipNo }}</div>
                <div>Firm Reg No : {{ footer.firmRegNo }}</div>
            </div>

            <!-- Right block -->
            <div class="footer-right">
                <div><b>Dated :</b> {{ footer.date }}</div>
                <br>
                <div class="trustees-line">TRUSTEES</div>
            </div>
        </div>
    </div>
</div>